module.exports = __webpack_public_path__ + "static/media/engine.bf88074a.jpg";